import moment from 'moment';
import React from 'react';
import { statusValues } from '../constant';

export const platformsConfig = {
  1: "ATD",
  2: "ION",
  3: "Meta",
  4: "Google Ads",
  5: "DV360",
  6: "GAM",
  7: "TikTok",
  8: "ViAds",
  9: "IOH"
}

export const options = {
  columns: [
    // { id: 1, name: 'campaignId', label: 'Date', sortable: true, type: 'date', component: row => moment(row.Date).format('D-MMM-YY'), },
    // { id: 1, name: 'campaignId', label: '', sortable: true, type: 'string',expand: true },
    { id: 2, name: 'campaignName', label: 'CAMPAIGN NAME', sortable: true, type: 'string', component: row => (row.campaignName) },
    { id: 3, name: 'platform', label: 'PLATFORM', sortable: false, type: 'string', component: (row) => row.platform == 1 ? "ATD" : row.platform == 2 ? "ION" : row.platform == 3 ? "Meta" : row.platform == 4 ? "Google Adwords" : row.platform == 5 ? "DV 360" : row.platform == 6 ? "GAM" : row.platform == 7 ? "TikTok" : row.platform == 8 ? "ViAds" : row.platform == 9 ? "IOH" : "" },
    { id: 4, name: 'campaignId', label: 'CAMPAIGN ID', sortable: false, type: 'string' },
    { id: 5, name: 'type', label: 'TYPE', sortable: true, type: 'string', component: (row) => row.type == 0 ? "Display" : row.type == 1 ? "Video" : row.type == 2 ? "Search" : row.type == 3 ? "Display, Video" : row.type == 4 ? "Video" : "-" },
    { id: 6, name: 'budget', label: 'BUDGET($)', sortable: true, type: 'number' },
    { id: 7, name: 'startDate', label: 'START DATE', sortable: true, type: 'date', component: row => moment(row.startDate).format('D-MMM-YY') },
    { id: 8, name: 'endDate', label: 'END DATE', sortable: true, type: 'date', component: row => row.endDate ? moment(row.endDate).format('D-MMM-YY') : '-' },
    {
      id: 9, name: 'status', label: 'STATUS', sortable: false, type: 'string', component: (row) => {
        const badgeData = statusValues[row.status];

        return <p className={`badge ${badgeData.cssClass}`}>{badgeData.text}</p>;
      }
    },
    { id: 10, name: 'recos', label: 'RECOM...', sortable: true, type: 'number', component: (row) => <div class="d-flex align-items-center">{row.recos} <a href={row.recos}><i class="ti ti-external-link ti-xs pl-1 text-primary"></i></a> </div> }


  ],
  keyCol: 'id',
  actions: [
    {
      type: 'view',
      text: '',
      icon: 'ti ti-eye color-beki',
      tooltip: 'View',
      iconType: 'new'
    },
    {
      type: 'edit',
      text: '',
      icon: 'ti ti-pencil color-beki',
      tooltip: 'Edit',
      iconType: 'new'
    },
    {
      type: "download",
      text: "",
      icon: "ti ti-file-download color-beki",
      tooltip: "Download SDF File",
      iconType: "new",
    },
    {
      type: 'chart',
      text: '',
      icon: 'ti ti-chart-bar color-beki',
      tooltip: 'View Campign',
      iconType: 'new'
    },
    {
      type: 'error',
      text: '',
      icon: 'mdi mdi-alert',
      tooltip: 'Error',
      iconType: 'new'
    }
  ],
  recActive: true,
  showSwitch: true,
  status: {
    key: 'status',
    active: '1',
    draft: 2,
    activeIcon: 'mdi mdi-checkbox-marked',
    inActiveIcon: 'mdi mdi-close-box',
    confirmation: true,
    activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
    inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
  },
  actionsThead: true,
  sortable: true,
  dateType: true,

  defaultSortParams: {
    sortBy: 'Date',
    sortOrder: 'desc'
  },
}
